import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';
import { ProgressBar } from 'react-bootstrap';
import { downloadBulkUploadTemplate } from '../../utils/bulkUploadTemplates';

function ProgramsCreate() {
  const navigate = useNavigate();
  const [programName, setProgramName] = useState('');
  const [programCode, setProgramCode] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [tooltip, setTooltip] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [activeTab, setActiveTab] = useState('single');

  useEffect(() => {
    axios.get('/api/program-categories')
      .then(response => setCategories(response.data))
      .catch(err => console.error(err));
  }, []);

  const handleSingleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: programName,
      code: programCode,
      programCategory: { id: parseInt(selectedCategory, 10) }
    };
    axios.post('/api/programs', payload)
      .then(() => {
        setTooltip('Program created successfully!');
        setTimeout(() => navigate('/admin/programs/view'), 2000);
      })
      .catch(err => {
        console.error(err);
        setTooltip('Error creating program.');
      });
  };

  const handleBulkSubmit = (e) => {
    e.preventDefault();
    if (!uploadFile) return;
    setUploadProgress(1);
    const formData = new FormData();
    formData.append('file', uploadFile);
    axios.post('/api/bulk-upload/programs', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percent);
      }
    })
      .then(() => {
        setTooltip('Programs uploaded successfully!');
        setUploadProgress(100);
        setTimeout(() => navigate('/admin/programs/view'), 2000);
      })
      .catch(err => {
        let backendMessage = ' Error uploading programs.';
        if (err.response && err.response.data) {
          if (typeof err.response.data === 'string') {
            backendMessage = err.response.data;
          } else if (typeof err.response.data.message === 'string') {
            backendMessage = err.response.data.message;
          }
        }
        setTooltip(`Error: ${backendMessage}`);
      });
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create New Program" />
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'single' ? 'active' : ''}`}
            onClick={() => setActiveTab('single')}
          >
            Single Create
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
            onClick={() => setActiveTab('bulk')}
          >
            Bulk Upload
          </button>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab === 'single' && (
          <div className="tab-pane active">
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={handleSingleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Program Name</label>
                    <input 
                      type="text"
                      className="form-control"
                      value={programName}
                      onChange={(e) => setProgramName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Program Code</label>
                    <input 
                      type="text"
                      className="form-control"
                      value={programCode}
                      onChange={(e) => setProgramCode(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Program Category</label>
                    <select 
                      className="form-select"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      required
                    >
                      <option value="">Select Category</option>
                      {categories.map(cat => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button type="submit" className="btn btn-primary">Create Program</button>
                </form>
              </div>
            </div>
          </div>
        )}
        {activeTab === 'bulk' && (
          <div className="tab-pane active">
            <div className="card shadow-sm">
              <div className="card-body">
                <form onSubmit={handleBulkSubmit}>
                  <div className="mb-3">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => downloadBulkUploadTemplate('programs')}
                    >
                      Download Template
                    </button>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Select Excel File</label>
                    <input 
                      type="file"
                      className="form-control"
                      accept=".xls,.xlsx"
                      onChange={(e) => {
                        setUploadFile(e.target.files[0]);
                        setUploadProgress(0);
                      }}
                    />
                  </div>
                  {uploadFile && (
                    <p className="fst-italic">File selected: {uploadFile.name}</p>
                  )}
                   {uploadProgress >= 1 && (
                    <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} animated striped className="mb-3" />
                   )}
                  <button type="submit" className="btn btn-primary">Upload Programs</button>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      {tooltip && (
        <div className={`mt-3 alert ${tooltip.startsWith('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default ProgramsCreate;
